/**
 * MapLibre GL JS configuration for the Service Directory
 *
 * This configuration uses OpenFreeMap tiles which require no API key
 * and are free to use at any scale.
 *
 * @see https://openfreemap.org/
 * @see https://maplibre.org/
 */

/**
 * Map configuration constants
 */
export const MAP_CONFIG = {
  /**
   * OpenFreeMap tile style URL
   * Liberty style provides a clean, modern look suitable for service directories
   */
  tileStyle: 'https://tiles.openfreemap.org/styles/liberty',

  /**
   * Default center coordinates for Ohio
   * Approximate geographic center of Ohio for initial map view
   */
  defaultCenter: {
    lat: 39.9612,
    lng: -82.9988,
  },

  /**
   * Default zoom level for initial map view
   * Zoom level 7 shows the entire state of Ohio
   */
  defaultZoom: 7,

  /**
   * Minimum zoom level allowed
   * Prevents zooming out too far
   */
  minZoom: 6,

  /**
   * Maximum zoom level allowed
   * Zoom level 18 provides street-level detail
   */
  maxZoom: 18,

  /**
   * Radius (in pixels) for clustering nearby points
   * Higher values create larger clusters
   */
  clusterRadius: 50,

  /**
   * Maximum zoom level at which points are clustered
   * Points are shown individually above this zoom level
   */
  clusterMaxZoom: 14,
} as const;

/**
 * Type for the map configuration object
 */
export type MapConfig = typeof MAP_CONFIG;

/**
 * Default initial view state for the map
 * Derived from MAP_CONFIG for convenience
 */
export const DEFAULT_VIEW_STATE = {
  longitude: MAP_CONFIG.defaultCenter.lng,
  latitude: MAP_CONFIG.defaultCenter.lat,
  zoom: MAP_CONFIG.defaultZoom,
} as const;

/**
 * Cluster configuration for MapLibre source
 */
export const CLUSTER_CONFIG = {
  cluster: true,
  clusterMaxZoom: MAP_CONFIG.clusterMaxZoom,
  clusterRadius: MAP_CONFIG.clusterRadius,
} as const;
